import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import useTranslation from "hooks/use_translation"

import useAppStore from "store/app"

import NoClientData from "../NoClientData"
import DangerAlert from "components/shared/alerts/Danger"
import WarningAlert from "components/shared/alerts/Warning"
import SuccessAlert from "components/shared/alerts/Success"
import Symptoms from "./Symptoms"
import DiseaseList from "./DiseaseList"

const Screening = ({ screening_id }) => {
  const [screening, setScreening] = useState()
  const [symptoms, setSymptoms] = useState()
  const [diseases, setDiseases] = useState()

  const getClientAnamnesis = useAppStore((state) => state.getClientAnamnesis)
  const { pages } = useTranslation()

  useEffect(() => {
    fetchScreening()
  }, [])

  const fetchScreening = () => {
    getClientAnamnesis(screening_id).then((response) => {
      const data = response.data

      setScreening(data)
      setSymptoms(data?.symptoms)
      const diseases =
        data.possible_diseases.length > 10
          ? data.possible_diseases.filter((disease) => parseInt(disease.match * 100) >= 50)
          : data.possible_diseases
      setDiseases(diseases)
    })
  }

  const selectCard = () => {
    const dangerMatches = symptoms.some((item) => item.danger === "high")
    const warningMatches = symptoms.some((item) => item.danger === "medium")

    if (dangerMatches) {
      return <DangerAlert />
    } else if (warningMatches) {
      return <WarningAlert />
    } else {
      return <SuccessAlert />
    }
  }

  if (!screening) {
    return <NoClientData description={pages?.history_of_requests?.no_data} />
  }

  return (
    <Box sx={{ mb: 6 }}>
      <Box sx={{ mb: 2.5 }}>{selectCard()}</Box>
      <Symptoms data={symptoms} />
      <DiseaseList created_at={screening?.created_at} data={diseases} />
    </Box>
  )
}

export default Screening
